import axios from "axios";
import { BASE_URL, FILES_BASE_URL, STRAPI_API_TOKEN, STRAPI_BASE_URL } from "../api/baseURL";
import { clearLocalStorageForUnauthorized } from "../utils";

export const LOCAL_STORAGE_NAME = "CUSTOMER_PORTAL"


const Axios = axios.create({
  baseURL: `${BASE_URL}`,
});

Axios.interceptors.request.use(
  (config) => {
    if (config.url =="/token") {
      config.headers["Content-Type"] = "application/x-www-form-urlencoded"
    }
    else {
      config.headers["Content-Type"] = "application/json"
    }
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_NAME))?.access_token || "";
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

Axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // A background read must never end the session. Calls the customer is
    // waiting on should discover an expired token and clear it; ambient ones
    // fired on sign-in, on app resume or on a panel open should not, or an
    // endpoint that is not deployed yet answering 401 instead of 404 signs
    // everyone out the moment they sign in. Opt in with
    // `{ skipUnauthorizedRedirect: true }` (see api/pushServices).
    const isAmbient = error.config?.skipUnauthorizedRedirect === true;
    if (error.response && error.response.status == 401 && !isAmbient) {
      clearLocalStorageForUnauthorized()
    }
    return Promise.reject(error);
  }
);

export const AxiosStrapi = axios.create({
  baseURL: `${STRAPI_BASE_URL}`,
});

AxiosStrapi.interceptors.request.use(
  (config) => {
    config.headers.Authorization = `bearer ${STRAPI_API_TOKEN}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const AxiosFiles = axios.create({
  baseURL: `${FILES_BASE_URL}`,
});
AxiosFiles.interceptors.request.use(
  (config) => {
    config.headers["Content-Type"] = "application/json"

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);




export default Axios;
